import { computed, unref } from 'vue';

import { propsFactory, paramCase } from '@components/utils';

import type { ComputedRef, PropType } from 'vue';

export interface IInvertColorProps {
  invertColor: boolean;
}
export interface IUseInvertColor {
  invertColorClasses: ComputedRef<string | undefined>;
}

export const makeInvertColor = propsFactory(
  {
    /**
     * !DEPRECATED! Инвертирует цветовую схему компонента
     */
    invertColor: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  'invert-color'
);

export function useInvertColor(props: IInvertColorProps, name: string): IUseInvertColor {
  const invertColorClasses = computed(() => {
    const { invertColor } = unref(props);
    return invertColor ? `${paramCase(name)}--invert-color` : undefined;
  });

  return { invertColorClasses };
}
